import 'babel-polyfill'
import axiosCommon from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import xesBaseFn from '~common/assets/js/xes.base.js'
import JY_CONFIG from './config'
import utils from './utils'

let axios = axiosCommon.create()
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

const NODE_ENV = process.env.NODE_ENV
const JY_NAME = jiaoyan_project.name
const PROTOCOL = location.protocol || 'https:'

// 根据项目和环境配置接口域名
if (NODE_ENV === 'test' || NODE_ENV === 'production') {
  // 在测试和线上环境下根据项目配置接口api域名
  axios.defaults.baseURL = JY_CONFIG.baseURL[JY_NAME][PROTOCOL]
}

window.token = xesBaseFn.getCookie('token')
axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded;charset=UTF-8'
if (JY_CONFIG.tnt.includes(JY_NAME)) {
  let newUrl = ''
  if (Number(utils.getParams('school_id')) === 1) { // 盈利
    newUrl = `${PROTOCOL}//tnt.saasz.vdyoo.com/#/`
  }
  if (Number(utils.getParams('school_id')) === 100) { // 非盈利
    newUrl = `${PROTOCOL}//tntxk.saasz.vdyoo.com/#/`
  }
  axios.defaults.logoutUrl = utils.getParams('domain') || newUrl
  // axios.defaults.logoutUrl = `${PROTOCOL}//tnt.xesv5.com`
} else {
  axios.defaults.logoutUrl = `${PROTOCOL}//admin.xesv5.com/`
}
axios.defaults.debug = true
axios.defaults.timeout = 300000
let CancelToken = axiosCommon.CancelToken
// 过滤需要特殊化处理接口请求错误信息的提示效果项目
axios.defaults.log = txt => {
  if (axios.defaults.debug) {
    console.log(txt)
  }
}
// 请求拦截器
axios.interceptors.request.use(
  config => {
    window.token = xesBaseFn.getCookie('token')
    if (JY_CONFIG.jytoken.includes(JY_NAME) && !config.noToken) {
      // header传jytoken
      config.headers['jytoken'] = window.token
    }
    var _url = config.url.replace(axios.defaults.baseURL, '')
    axios.defaults.log('\n******  请求开始 ' + _url + ' ******')
    let cancelGroupName
    if (config.method === 'post' && config.formType != '1') {
      if (config.data && config.data.cancelGroupName) {
        // post请求ajax取消函数配置
        cancelGroupName = config.data.cancelGroupName
      }
      if (!JY_CONFIG.jytoken.includes(JY_NAME)) {
        config.data
          ? (config.data.token = window.token)
          : (config.data = { token: window.token })
      }
      config.data = qs.stringify(config.data)
    }
    if (config.formType == '1') {
      // formType == 1上传文件模式，为formdata添加token
      if (config.data && !JY_CONFIG.jytoken.includes(JY_NAME)) {
        config.data.append('token', window.token)
      }
    }
    if (config.method === 'get') {
      if (config.params && config.params.cancelGroupName) {
        // get请求ajax取消函数配置
        cancelGroupName = config.params.cancelGroupName
      }
      if (!JY_CONFIG.jytoken.includes(JY_NAME)) {
        config.params
          ? (config.params.token = window.token)
          : (config.params = { token: window.token })
      }
    }

    if (cancelGroupName) {
      if (axios[cancelGroupName] && axios[cancelGroupName].cancel) {
        axios[cancelGroupName].cancel()
      }
      config.cancelToken = new CancelToken(c => {
        axios[cancelGroupName] = {}
        axios[cancelGroupName].cancel = c
      })
    }
    return config
  },
  error => {
    Message.error({
      message: '加载超时'
    })
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  res => {
    var _url = res.config.url.replace(axios.defaults.baseURL, '')
    if (res.data.status === 100 || res.data.stat === 1) {
      axios.defaults.log('\n******  请求成功 ' + _url + '  ******')
      axios.defaults.log(res.data)
      return res.data
    } else {
      if (res.data.status == 1006) {
        // 门户扫码轮询接口 需要返回正常
        if (
          JY_NAME == 'jiaoyanmenhu' &&
          _url.indexOf('login/checkQrcodeStatus') > -1
        ) {
          axios.defaults.log(
            '\n******  扫码请求 ' + _url + '  ******'
          )
          axios.defaults.log(res.data)
          return res.data
        }
      }
      if (res.data.status === 1001 || res.data.status === 1002) {
        if (JY_NAME == 'jiaoyanmenhu') {
          if (
            _url.indexOf('login/checkQrcodeStatus') > -1 ||
            _url.indexOf('login/checkPwd') > -1
          ) {
            return res.data
          } else {
            return Promise.reject(res.data)
          }
        } else if (JY_NAME == 'workflow') {
          // 工作流
          Message.error({
            message: res.data.data
          })
        } else {
          xesBaseFn.delCookie('token').then(() => {
            logout(res.data.data)
          })
        }
        return
      }
      if (
        res.data.status === 1004 &&
        (JY_NAME == 'tikuProduction' || JY_NAME == 'userVoice')
      ) {
        xesBaseFn.delCookie('token').then(() => {
          logout(res.data.data)
        })
        return Promise.reject(res.data)
      }
      axios.defaults.log(
        '\n******  ' +
        _url +
        ' 错误编码：' +
        res.data.status +
        '  ******'
      )
      // 判断有些错误信息提示个性化除外
      if (JY_CONFIG.customTips.includes(JY_NAME)) {
        return Promise.reject(res.data)
      }
      // 统一处理提示
      Message.error({
        message: res.data.data
      })
      return Promise.reject(res.data)
    }
  },
  error => {
    // 中断请求的不提示
    if (axios.isCancel(error)) return false
    let errorMsg = '网络异常，请刷新重试！'
    error.data = errorMsg
    // 判断有些错误信息提示个性化除外
    if (JY_CONFIG.customTips.includes(JY_NAME)) {
      return Promise.reject(error)
    }
    // 统一处理提示
    Message.error({
      message: error.data
    })
    return Promise.reject(error)
  }
)
function logout (txt) {
  MessageBox.alert(txt, '提示', {
    confirmButtonText: '确定',
    callback: action => {
      window.location.href = axios.defaults.logoutUrl
    }
  })
}
export default axios



// WEBPACK FOOTER //
// ./common/assets/js/axios.js